import { UserModel } from '../user.model';
import { ActToken } from '../../services/authentication/authentication.service';
export class LoginResponseModel {
    user: UserModel;
    token: ActToken;

    constructor(user?: UserModel, token?: ActToken) {
        this.user = user;
        this.token = token;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/login/login-response.model.ts